import React from 'react';
import ReactStars from 'react-stars';
import { useHistory } from 'react-router-dom';

import {
  convertLanguageArray,
  convertToTitleCase,
  extractCountryCodeFromAddress,
  getCountryFlagImage,
} from '../../../util/data';
import { createResourceLocatorString } from '../../../util/routes';

import { AvatarLarge, IconBrandCard } from '../../../components';

import css from '../ProfilePage.module.css';

const AsideContent = props => {
  const {
    user,
    displayName,
    endorsedUsers,
    reviews,
    routeConfiguration,
    isCurrentUser,
    isCustomer,
  } = props;

  const history = useHistory();
  // Extract the ratings
  const ratings = reviews.map(review => review.attributes.rating);

  // Calculate the average rating
  const averageRating = ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;
  const publicData = user.attributes.profile.publicData ?? {};
  const countryCode = extractCountryCodeFromAddress(publicData?.location?.address);

  return (
    <div className={css.asideContent}>
      {isCurrentUser && (
        <div className={css.editProfileLink}>
          <span
            onClick={() => {
              history.push(
                createResourceLocatorString('ProfileSettingsPage', routeConfiguration, {}, {})
              );
            }}
            className={css.editProfileText}
          >
            Edit
          </span>
        </div>
      )}
      <div className={css.asideTopbar}>
        <AvatarLarge className={css.avatar} user={user} disableProfileLink />
        <div className={css.profileTitle}>
          {!getCountryFlagImage(countryCode)?.includes('null') && (
            <img src={getCountryFlagImage(countryCode)} alt="flag" />
          )}
          {displayName}
        </div>
        {publicData?.location?.address && (
          <div className={css.profileName}>
            <IconBrandCard type="location" />
            {publicData?.location?.address}
          </div>
        )}
        {!isCustomer && (
          <div className={css.profileRating}>
            <ReactStars
              count={5} // Maximum stars (change as needed)
              value={averageRating} // Set value to the average rating
              onChange={() => {}} // Empty function as it's read-only
              size={20}
              isHalf={true}
              edit={false}
              color1={'#ccc'}
              color2={'#000'}
              emptyIcon={<i className="fa fa-star" />}
              filledIcon={<i className="fa fa-star" />}
            />
          </div>
        )}
      </div>

      {!isCustomer && (
        <div className={css.asideCardWrapper}>
          <div className={css.cardHeading}>Endorsements</div>
          <div className={css.cardList}>
            {endorsedUsers?.length > 0 ? (
              endorsedUsers.map((user, index) => (
                <span
                  key={user?.id?.uuid}
                  onClick={() => {
                    history.push(
                      createResourceLocatorString(
                        'ProfilePage',
                        routeConfiguration,
                        { id: user?.id?.uuid },
                        {}
                      )
                    );
                  }}
                  className={css.endorsementsName}
                >
                  {user?.attributes?.profile?.displayName}
                  {index !== endorsedUsers.length - 1 && ', '}
                </span>
              ))
            ) : (
              <span className={css.endorsementsNameW}>
                No endorsements yet? Find and invite tribe members
              </span>
            )}
          </div>
        </div>
      )}

      {!isCustomer &&
        (Array.isArray(publicData?.wisdom_ways) && publicData.wisdom_ways.length > 0 ? (
          <div className={css.asideCardWrapper}>
            <div className={css.cardHeading}>Wisdom and Ways</div>
            <div className={css.cardListRow}>
              {publicData.wisdom_ways
                .sort((a, b) => a.length - b.length)
                .map((data, i) => (
                  <span key={i} className={css.wisdomName}>
                    {convertToTitleCase(data)}
                  </span>
                ))}
            </div>
          </div>
        ) : (
          <div className={css.asideCardWrapper}>
            <div className={css.cardHeading}>Wisdom and Ways</div>
            <div className={css.cardListRow}>
              <span className={css.wisdomName}>Not found</span>
            </div>
          </div>
        ))}

      {publicData?.languages?.length > 0 && (
        <div className={css.lanCardWrapper}>
          <div className={css.cardHeading}>Languages</div>
          <div className={css.languagesList}>
            <span className={css.lanName}>
              {publicData?.languages?.length > 0
                ? convertLanguageArray(publicData?.languages).join(', ')
                : 'No languages available'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AsideContent;
